import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useMemo } from 'preact/hooks';
import { CopyButton } from '@/components/common/CopyButton';
// Escape values destined for double-quoted HTML attributes. The snippet text
// is what the customer pastes onto their own site, so escape defensively even
// though our IDs/URLs aren't user-controlled.
function escapeAttr(value) {
    return value
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}
function buildSnippet({ TrackingId, ScriptUrl, WorkspaceId, CampaignId, LandingPageId, }) {
    const attrs = [`data-tracking-id="${escapeAttr(TrackingId)}"`];
    if (WorkspaceId)
        attrs.push(`data-workspace-id="${escapeAttr(WorkspaceId)}"`);
    if (CampaignId)
        attrs.push(`data-campaign-id="${escapeAttr(CampaignId)}"`);
    if (LandingPageId)
        attrs.push(`data-landing-page-id="${escapeAttr(LandingPageId)}"`);
    const indented = attrs.map((a, i) => (i === 0 ? a : `  ${a}`)).join('\n');
    return `<script async src="${escapeAttr(ScriptUrl)}"\n  ${indented}></script>`;
}
export const TrackingSnippet = ({ TrackingId, ScriptUrl, WorkspaceId, CampaignId, LandingPageId, label = 'Tracking snippet', }) => {
    const snippet = useMemo(() => buildSnippet({ TrackingId, ScriptUrl, WorkspaceId, CampaignId, LandingPageId }), [TrackingId, ScriptUrl, WorkspaceId, CampaignId, LandingPageId]);
    return (_jsxs("div", { className: "relative rounded-lg border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-800/60", children: [_jsx("pre", { className: "m-0 p-3 pr-10 font-mono text-xs leading-relaxed text-slate-800 dark:text-slate-100 whitespace-pre-wrap break-all", children: snippet }), _jsx("div", { className: "absolute top-1.5 right-1.5", children: _jsx(CopyButton, { text: snippet, label: label, variant: "icon-only" }) })] }));
};
